import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

interface CustomButton {
        size?: string;
        theme?: string;
        tag?: string;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomButton',
  props: {
    size: { default: 'md' },
    theme: { default: 'danger' },
    tag: {}
  },
  emits: ['click'],
  setup(__props: any) {

    

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag || 'button'), {
    class: _normalizeClass(["btn", {
            [`btn--theme-${_ctx.theme}`]: true,
            [`btn--size-${_ctx.size}`]: true,
        }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})